import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import FiltersStore from '../../../../stores/FiltersStore';
import FiltersActions from '../../../../actions/FiltersActions';
import FiltersConstants from '../../../../constants/FiltersConstants';
import Analytics from 'arbitrip-common/client/analytics';

import FilterCheckboxWithLabel from './components/FilterCheckboxWithLabel.react';

function BookingOptionsFilter({ profile, freeCancellationFilter, amenitiesFilter }) {
	const { t } = useTranslation();

	const updateBreakfastFilter = useCallback(() => {
		const results_breakfast_filter = amenitiesFilter[FiltersConstants.AMENITIES.BREAKFAST_INCLUDED];
		if (FiltersStore.getDealsBreakfastFilterData() !== results_breakfast_filter) {
			setTimeout(
				() =>
					// dispatch in middle of dispatcher patch
					FiltersActions.filterDealsByBreakfastOnly(results_breakfast_filter),
				1,
			);
		}
	}, [amenitiesFilter]);

	useEffect(() => {
		// update breakfast filter on hotel page when component is mount
		updateBreakfastFilter();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleFreeCancellationChange = (isInputChecked) => {
		FiltersActions.filterByFreeCancellation(isInputChecked);

		const filter_value = t(isInputChecked ? 'FreeCancellationOnly' : 'ShowAll');
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.FREE_CANCELLATION,
			filter_value,
		);
	};

	const handleBreakfastChange = (event, isInputChecked) => {
		event.persist();

		const amenity = FiltersConstants.AMENITIES.BREAKFAST_INCLUDED;

		FiltersActions.filterByAmenity(amenity, isInputChecked);
		setTimeout(() => {
			FiltersActions.filterByAmenity(amenity, isInputChecked);
		}, 10);

		const filter_value = t(isInputChecked ? 'FilterByAmenity' : 'DontFilterByAmenity', { amenity });
		Analytics.actions.interactions.filteredResults(profile, FiltersConstants.FILTER_METHOD.AMENITIES, filter_value);

		updateBreakfastFilter();
	};

	return (
		<div className="filter">
			<label className="filter-title" htmlFor="booking-options-filter">
				{t('BookingOptionsFilterTitle')}
			</label>
			<div name="booking-options-filter" className="check-list" aria-label={t('BookingOptionsFilterTitle')}>
				<div className="checkbox-container">
					<FilterCheckboxWithLabel
						checked={freeCancellationFilter}
						label={t('FreeCancellation')}
						onChange={(e, c) => handleFreeCancellationChange(c)}
					/>
				</div>
				<div className="checkbox-container">
					<FilterCheckboxWithLabel
						checked={amenitiesFilter[FiltersConstants.AMENITIES.BREAKFAST_INCLUDED]}
						label={t('AMENITY_BREAKFAST_INCLUDED')}
						onChange={handleBreakfastChange}
					/>
				</div>
			</div>
		</div>
	);
}

export default BookingOptionsFilter;
